import { colors } from './colors';
import { fonts } from './fonts';

export default {
  colors,
  fonts
};
